module.exports = __webpack_public_path__ + "img/trend-shape-decrease.2734dba5.png";